"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var PropTypes = require("prop-types");
var utils_1 = require("../../utils");
var Tag_st_css_1 = require("./Tag.st.css");
var SPACE_KEY = 32;
var FocusableTag = /** @class */ (function (_super) {
    tslib_1.__extends(FocusableTag, _super);
    function FocusableTag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        _this.labelRef = React.createRef();
        _this.anchorRef = React.createRef();
        _this.handleKeyDown = function (ev) {
            var link = _this.props.link;
            /**
             * By default, list item can't be selected by Space button,
             * so we call click on input.
             * Also, keyCode is 100% cross-browser - number 32 is everywhere
             */
            // tslint:disable-next-line: deprecation
            if (ev.keyCode === SPACE_KEY) {
                ev.preventDefault();
                _this.inputRef.current.click();
                /**
                 * We need to preserve focus on selected-deselected element,
                 * so we need to set focus on wrapper, when chain of events
                 * click -> change -> blur will be fired
                 */
                var PAUSE_FOR_BLUR_EVENT = 10;
                setTimeout(function () {
                    if (link) {
                        _this.anchorRef.current.focus();
                    }
                    else {
                        _this.labelRef.current.focus();
                    }
                }, PAUSE_FOR_BLUR_EVENT);
            }
        };
        _this.handleTagClick = function (ev) {
            ev.preventDefault();
            /**
             * Label wrapped in anchor, so we simulate click on input
             * to fire change event and onChange listener.
             */
            _this.inputRef.current.click();
        };
        _this.renderLabeledInput = function (ownProps, wrapperProps) {
            if (wrapperProps === void 0) { wrapperProps = {}; }
            var value = ownProps.value, label = ownProps.label, disabled = ownProps.disabled, checked = ownProps.checked, onChange = ownProps.onChange, compId = ownProps.compId, children = ownProps.children, uniqueId = ownProps.uniqueId, tabIndex = ownProps.tabIndex;
            return (React.createElement("label", tslib_1.__assign({ ref: _this.labelRef, "data-hook": "tags-list-tag" /* Tag */, title: label, htmlFor: uniqueId, tabIndex: tabIndex }, wrapperProps),
                React.createElement("input", { ref: _this.inputRef, "data-hook": "tags-list-tag-input" /* TagInput */, className: Tag_st_css_1.default.tagInput, type: "checkbox", checked: checked, onChange: onChange, value: value, name: compId || label, id: uniqueId, disabled: disabled }),
                children));
        };
        return _this;
    }
    FocusableTag.prototype.render = function () {
        var _a = this.props, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, disabled = _a.disabled, checked = _a.checked, link = _a.link, rel = _a.rel, _d = _a.onChange, onChange = _d === void 0 ? utils_1.noop : _d, compId = _a.compId, tagIndex = _a.tagIndex, children = _a.children, className = _a.className, 
        /**
         * component props may contain non-deterministically-named attribute
         * created by "stylable" and used as css-selector.
         * This variable will keep it and forward to root element.
         */
        wrapperStyles = tslib_1.__rest(_a, ["value", "label", "disabled", "checked", "link", "rel", "onChange", "compId", "tagIndex", "children", "className"]);
        var uniqueId = tagIndex !== undefined
            ? value + "-" + compId + "-" + tagIndex
            : value + "-" + compId;
        var isFocusDisabled = Boolean(disabled || link);
        var tabIndex = isFocusDisabled ? -1 : 0;
        var rootElementProps = tslib_1.__assign({ onKeyDown: this.handleKeyDown, className: classNames(Tag_st_css_1.default.tag, className) }, wrapperStyles);
        var labeledInputProps = {
            value: value,
            label: label,
            disabled: disabled,
            checked: checked,
            onChange: onChange,
            tabIndex: tabIndex,
            uniqueId: uniqueId,
            compId: compId,
            children: children,
        };
        return link ? (React.createElement("a", tslib_1.__assign({ ref: this.anchorRef, role: "checkbox", "aria-checked": checked, "aria-disabled": disabled, href: link, rel: rel, tabIndex: disabled ? -1 : 0, onClick: this.handleTagClick }, rootElementProps), this.renderLabeledInput(labeledInputProps))) : (this.renderLabeledInput(labeledInputProps, rootElementProps));
    };
    FocusableTag.displayName = "Tag" /* Tag */;
    FocusableTag.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        checked: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
        onChange: PropTypes.func,
        link: PropTypes.string,
        rel: PropTypes.string,
        compId: PropTypes.string,
        tagIndex: PropTypes.number,
        style: PropTypes.object,
    };
    return FocusableTag;
}(React.Component));
exports.FocusableTag = FocusableTag;
var Tag = /** @class */ (function (_super) {
    tslib_1.__extends(Tag, _super);
    function Tag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        _this.labelRef = React.createRef();
        _this.anchorRef = React.createRef();
        _this.handleKeyDown = function (ev) {
            var link = _this.props.link;
            /**
             * By default, list item can't be selected by Space button,
             * so we call click on input.
             * Also, keyCode is 100% cross-browser - number 32 is everywhere
             */
            // tslint:disable-next-line: deprecation
            if (ev.keyCode === SPACE_KEY) {
                ev.preventDefault();
                _this.inputRef.current.click();
                /**
                 * We need to preserve focus on selected-deselected element,
                 * so we need to set focus on wrapper, when chain of events
                 * click -> change -> blur will be fired
                 */
                var PAUSE_FOR_BLUR_EVENT = 10;
                setTimeout(function () {
                    if (link) {
                        _this.anchorRef.current.focus();
                    }
                    else {
                        _this.labelRef.current.focus();
                    }
                }, PAUSE_FOR_BLUR_EVENT);
            }
        };
        _this.handleTagClick = function (ev) {
            ev.preventDefault();
            /**
             * Label wrapped in anchor, so we simulate click on input
             * to fire change event and onChange listener.
             */
            _this.inputRef.current.click();
        };
        return _this;
    }
    Tag.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, disabled = _a.disabled, checked = _a.checked, _d = _a.onChange, onChange = _d === void 0 ? utils_1.noop : _d, link = _a.link, rel = _a.rel, compId = _a.compId, tagIndex = _a.tagIndex, rest = tslib_1.__rest(_a, ["children", "className", "value", "label", "disabled", "checked", "onChange", "link", "rel", "compId", "tagIndex"]);
        var wrapperProps = tslib_1.__assign({ className: classNames(Tag_st_css_1.default.tag, className) }, rest);
        var LabeledInput = function (props) {
            // in case with link, we should focus anchor wrapper
            var isDisabledFocus = disabled || link;
            var uniqId = tagIndex !== undefined
                ? value + "-" + compId + "-" + tagIndex
                : value + "-" + compId;
            return (React.createElement("label", tslib_1.__assign({ ref: _this.labelRef, "data-hook": "tags-list-tag" /* Tag */, title: label, htmlFor: uniqId, tabIndex: isDisabledFocus ? -1 : 0 }, props),
                React.createElement("input", { ref: _this.inputRef, "data-hook": "tags-list-tag-input" /* TagInput */, className: Tag_st_css_1.default.tagInput, type: "checkbox", checked: checked, onChange: onChange, value: value, name: compId || label, id: uniqId, disabled: disabled }),
                children));
        };
        return link ? (React.createElement("a", tslib_1.__assign({ ref: this.anchorRef, role: "checkbox", "aria-checked": checked, "aria-disabled": disabled, href: link, rel: rel, tabIndex: disabled ? -1 : 0, onClick: this.handleTagClick, onKeyDown: this.handleKeyDown }, wrapperProps),
            React.createElement(LabeledInput, null))) : (React.createElement(LabeledInput, tslib_1.__assign({}, wrapperProps, { onKeyDown: this.handleKeyDown })));
    };
    Tag.displayName = "Tag" /* Tag */;
    Tag.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        checked: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
        onChange: PropTypes.func,
        link: PropTypes.string,
        rel: PropTypes.string,
        compId: PropTypes.string,
        tagIndex: PropTypes.number,
    };
    return Tag;
}(React.Component));
exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map